import React, { Component } from "react";
import MainCards from "./mainCards";
import { Layout, Divider } from "antd";

const { Content } = Layout;

class Gallery extends Component {
	constructor(props) {
		super(props);
		this.state = {
			key: "1",
			collapsed: true,
		};
	}

	toggle = () => {
		this.setState({
			collapsed: !this.state.collapsed,
		});
	};

	render() {
		return (
			<div className="mainDiv">
				<div>
					<div>
						<Layout className="layOut2">
							<Layout className="site-layout">
								{this.state.key === "1" ? (
									<Content
										className="site-layout-background"
										style={{
											padding: 24,
											minHeight: 280,
											textAlign: "center",
											fontSize: "40px",
										}}
									>
										<div className="marginTop">
											<Divider>Video Gallery</Divider>
											<MainCards />
										</div>
									</Content>
								) : this.state.key === "2" ? (
									<Content
										className="site-layout-background"
										style={{
											padding: 24,
											minHeight: 280,
											textAlign: "center",
											fontSize: "40px",
										}}
									>
										<div className="marginTop">
											<Divider>Courses</Divider>
										</div>
									</Content>
								) : this.state.key === "3" ? (
									<Content
										className="site-layout-background"
										style={{
											padding: 24,
											minHeight: 280,
											textAlign: "center",
											fontSize: "40px",
										}}
									>
										<div className="marginTop">
											<Divider>My Learning</Divider>
										</div>
									</Content>
								) : this.state.key === "4" ? (
									<Content
										className="site-layout-background"
										style={{
											padding: 24,
											minHeight: 280,
											textAlign: "center",
											fontSize: "40px",
										}}
									>
										<div className="marginTop">
											<Divider>People</Divider>
										</div>
									</Content>
								) : this.state.key === "5" ? (
									<Content
										className="site-layout-background"
										style={{
											padding: 24,
											minHeight: 280,
											textAlign: "center",
											fontSize: "40px",
										}}
									>
										<div className="marginTop">
											<Divider>Reports</Divider>
										</div>
									</Content>
								) : null}
							</Layout>
						</Layout>
					</div>
				</div>
			</div>
		);
	}
}
export default Gallery;
